import dotProp from 'dot-prop-immutable';
import translations from './translations.json';

export default function translate(key) {
    return dotProp.get(translations, key) || key;
}
